export enum DateFormat {
    Default = 'YYYY-MM-DD HH:mm:ss',
    DefaultDate = 'YYYY-MM-DD',
    DefaultTime = 'HH:mm',
    ExtendedTime = 'HH:mm:ss',
    Main = 'MMM DD, YYYY HH:mm',
    Date = 'MMM DD, YYYY',
    Day = 'ddd',
    FullDay = 'dddd',
    ExtendedDay = 'ddd, DD',
    BookedDate = 'dddd, DD MMM',
    BookedShortDate = 'MMM DD',
    BookedTime = 'hh:mm A',
    ShortDate = 'dddd, h:mm A',
    DatePicker = 'MMM DD, yyyy HH:mm',
    TimeSlot = 'h A',
    AmPm = 'h:mm A',
    DateWeek = 'ddd MMM DD, YYYY',
    DateFilter = 'MMM, DD YYYY HH:mm:ss'
}
